<template>
  <!-- 一个照片盒子 没有留白 -->
  <div class="id_15 clear">
    <div class="img_box" :class="{'cursor': data.url && data.radio !== 2}" @click="toPage(1)">
<!--      | imageFormat-->
      <img ref="img" :src="data.src">
      <div class="btn cursor" :style="data.style" @click="toPage(2)" v-if="data.url">
        {{$t('flowActive14')}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: Object
  },
  data () {
    return {
    }
  },
  methods: {
    // 跳转
    toPage (num) {
      // if (this.data.url) window.open(this.data.url)
      console.log(this.data, 'data')
      if (num === 1 && +this.data.radio === 2) {
        return
      }
      console.log(this.data.url, 'this.data.url')
      if (this.data.url) window.open(this.data.url)
    }
  }
}
</script>

<style lang="scss" scoped>
$width:100vw/1920;
$width1: 100vw /1920 / 936 * 1136;
.id_15{
  word-wrap:break-word;
  width: 100%;
  font-size: 0;
  line-height: 0;
  //.img_box{
  //  width: 100%;
  //  img{
  //    width: 100%;
  //  }
  //}
  .img_box{
    width: 100%;
    position: relative;
    img{
      width: 100%;
    }
    .btn {
      position: absolute;
      width: 168 * $width1;
      height: 38 * $width1;
      text-align: center;
      line-height: 38 * $width1;
      font-size: 16 * $width1;
      border-radius: 44 * $width1;
      font-family: OPPOSans-B, OPPOSans;
      font-weight: normal;
      color: #FFFFFF;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/module/details/public/id_15.vue